import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, {useRef } from "react";
import { usePresentacionContext } from "../context/presentacion.context";
import { NumericFormat } from "react-number-format";
import { Button } from "primereact/button";
import { Impuesto, ImpuestoResponse } from "../models/Impuesto.model";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import {
  impuestosDTOAdapterEmpty,
  impuestosPresentacionRequestEmpty,
} from "../adapters/impuesto.adapter";
import {
  actualizarImpuestosPresentacion,
  consultarImpuestosPresentacion,
  consultarImpuestosPresentacionAutomaticaActualizados,
  
} from "../services/impuestos.service";
import { INICIADA_COMERCIO } from "../utilities/constants";
import { ParametroDTO } from "../models/parametros.model";
import { comprobantesProcess } from "../utilities/comprobantes";

const ImpuestosTasasDataTableAutomatico = () => {
  const {
    spinnerImpuestosTasas,
    dataImpuestos,
    presentacion,
    setDataImpuestos,
    impuestosDefault,presentacionEditable,
    presentacionComercio,
    parametrosPresentacion,
    comprobantes
  } = usePresentacionContext();
  const toast = useRef<Toast>(null);
  const formatMoneyBodyTemplate = (monto: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={4}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };
  const formatITCBodyTemplate = (monto: any) => {
    return (
      <div className="p-d-flex p-ai-center p-jc-end">
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={4}
          fixedDecimalScale={true}
        />
        <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            //onClick={() => props.onClickEdit(rowData)}
            tooltip="Editar"
          >
            <i className="pi pi-pencil mr-2"/>
          </Button>
      </div>
    );
  };
  const declaradoBodyTemplate = (rowData: Impuesto) => {
    return (
      <React.Fragment>
        {rowData.declarado ? (
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            tooltip="Declarado"
            onClick={() => "return false;"}
          >
            <i
              className="pi pi-verified mr-2"
              style={{ fontSize: "1.5em", color: "var(--green-300)" }}
            ></i>
          </Button>
        ) : (
          <Button
            className="p-button-rounded p-button-text"
            aria-label="Filter"
            tooltip="No Declarado"
            onClick={() => "return false;"}
          >
            <i
              className="pi pi-ban mr-2"
              style={{ fontSize: "1.5em", color: "#e91224" }}
            />
          </Button>
        )}
      </React.Fragment>
    );
  };

  const textEditor = (options: any) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };

  

  const priceEditor = (options: any) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        mode="currency"
        currency="ARS"
        locale="es-AR"
        minFractionDigits={4}
      />
    );
  };
  const cellEditor = (options: any) => {
    if (options.field === "precioITC") return priceEditor(options);
    else return textEditor(options);
  };

  const onCellEditComplete = async (e: any) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    if(rowData.precioITC === newValue) return

    let toleranciaITC =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaITC")
    const TOLERANCIA_ITC = Number.isNaN(Number.parseFloat(toleranciaITC[0].valor)) ? 0 : parseFloat(toleranciaITC[0].valor)
      
    
    if(newValue !== 0 && rowData.precioITC !== 0 ){
      let impuestoFilter = impuestosDefault.filter((item:ImpuestoResponse) => item.idServicio === rowData.idServicio)
      if(impuestoFilter.length > 0) {
        let toleranciaITC = impuestoFilter[0].precioITC * TOLERANCIA_ITC
        let max = (impuestoFilter[0].precioITC + toleranciaITC)
        let min = (impuestoFilter[0].precioITC - toleranciaITC)
        if(newValue < min || newValue > max){
          toast.current?.show({life: 5000, severity: 'warn', summary: 'Message', detail: 'Tolerancia que no debe superar el ITC. El 45%'});
          return
        }
      }
    }
    switch (field) {
      case "precioITC":
        rowData[field] = newValue;
        let impuestosPresentacionAdapter = impuestosPresentacionRequestEmpty([]);
        impuestosPresentacionAdapter.PreCupon = presentacion;
        impuestosPresentacionAdapter.IdServicio = rowData.idServicio;
        impuestosPresentacionAdapter.Litros = rowData.litros;
        impuestosPresentacionAdapter.PrecioITC = Number(parseFloat(rowData.precioITC).toFixed(4))

        impuestosPresentacionAdapter.ListaImpuestos.push(impuestosDTOAdapterEmpty());

        let result = await actualizarImpuestosPresentacion(impuestosPresentacionAdapter );

        if (result.status === 200) {
          toast.current?.show({life: 5000, severity: 'success', summary: 'Message', detail: 'Impuesto actualizado correctamente.'});
          const {data,status} = await consultarImpuestosPresentacion(presentacion);
          if(status === 200 && data.impuestos.length > 0){
            setDataImpuestos(data)
          }else{
            toast.current?.show({life: 5000, severity: 'error', summary: 'Message', detail: 'Hubo un error al actualizar impuestos y tasas.'});
          }
          
        }else{
          toast.current?.show({life: 5000, severity: 'error', summary: 'Message', detail: 'Hubo un error al actualizar el impuesto ITC.'});
        }

        break;

      default:
        event.preventDefault()
        break;
    }
  };
  const onclickRecalcular = async() => {
    let resultImpuestosAutomatica = await consultarImpuestosPresentacionAutomaticaActualizados(presentacion);
    if(resultImpuestosAutomatica.status === 200 && resultImpuestosAutomatica.data.impuestos.length > 0){
      setDataImpuestos(resultImpuestosAutomatica.data)
    }else{
      toast.current?.show({life: 5000, severity: 'error', summary: 'Message', detail: 'Hubo un error al actualizar impuestos y tasas.'});
    }
  }

  let sumTotalImpuestos: number = comprobantesProcess(comprobantes).sumatoriaDeImpuestos;
  let totales =  [{
    headerTitle:"Total Declarado",
    totalGeneral:dataImpuestos.totalGeneral
  },{
    headerTitle: "Total Facturado",
    totalGeneral: sumTotalImpuestos
},
{
    headerTitle: "Diferencia",
    totalGeneral: dataImpuestos.totalGeneral - sumTotalImpuestos
}]


  const renderHeader = () => {
    return (
      presentacionComercio.descripcion === INICIADA_COMERCIO && <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12 p-md-6" style={{ textAlign: "left" }}>
        </div>
        <div className="p-col-12 p-md-6" style={{ textAlign: "end" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  className="vimeo p-0"
                  aria-label="Vimeo"
                  style={{ minWidth: "150px" }}
                  onClick={onclickRecalcular}
                  //disabled = {presentacionComercio.descripcion === RECHAZADA}
                  tooltip="Recalcular a valores de ITC predeterminados"
                  tooltipOptions={{ position: 'top', mouseTrack: true, mouseTrackTop: 15 }}
                >
                  <i className="pi pi-refresh px-2"></i>
                  <span className="px-3">Recalcular ITC Predeterminado</span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <Toast ref={toast} position="bottom-right" />
      <DataTable
        value={dataImpuestos.impuestos}
        header={() =>
          renderHeader()
        }
        responsiveLayout="stack"
        className="txDataTable"
        size="small"
        editMode="cell"
        loading={spinnerImpuestosTasas}
      >
        <Column
          field="servicioXBandera"
          header="Producto"
          style={{ width: "12%" }}
        />
        <Column
          field="litros"
          header="Litros"
          style={{ textAlign: "right", width: "12%" }}
        />
        {
          presentacionComercio.descripcion === INICIADA_COMERCIO 
          ? <Column
          field="precioITC"
          body={(rowData) => formatITCBodyTemplate(rowData.precioITC)}
          header="ITC"
          style={{ textAlign: "right", width: "12%" }}
          editor={(options) => cellEditor(options)}
          onCellEditComplete={onCellEditComplete}

        /> 
          :<Column
          field="precioITC"
          header="ITC"
          style={{ textAlign: "right", width: "12%" }}
        />
        }
        

        <Column
          field="totalServicio"
          header={<span style={{ textAlign: "center" }}>Total</span>}
          body={(rowData) => formatMoneyBodyTemplate(rowData.totalServicio)}
          style={{ textAlign: "right", width: "12%" }}
        />
      </DataTable>
      {!spinnerImpuestosTasas && <DataTable
            value={totales}
            responsiveLayout="stack"
            size="small"
            loading={spinnerImpuestosTasas}
            rowClassName={(row) => { return { 'row-diferencia': row.headerTitle === 'Diferencia' } }}
          >
            <Column field="headerTitle" style={{ width: "12%" }} />
            <Column style={{ textAlign: "right", width: "12%" }} />
            <Column
              field="totalPrecioITC"
              style={{ textAlign: "right", width: "12%" }}
              body={(rowData) => formatMoneyBodyTemplate(rowData.totalPrecioITC)}
            />
            <Column 
              field="totalGeneral" 
              style={{ textAlign: "right", width: "12%" }} 
              body={(rowData) => formatMoneyBodyTemplate(rowData.totalGeneral)}
              />
          </DataTable>}
    </>
  );
};

export default ImpuestosTasasDataTableAutomatico;
